{
  "articles": {
    "agents": {"question": "Which agents can I use, and how do I install one?"},
    "executableItems": {"question": "Which items count as tools?"},
    "githubConnection": {"question": "What does a connection do?"},
    "importCorpus": {"question": "How does an import run?"},
    "localImport": {"question": "What must the folder look like?"},
    "privateRepository": {"question": "How do I import a private repository?"}
  },
  "breadcrumbs": "You are here",
  "build": "DMW {{commit}} · {{started}}",
  "close": "Close help",
  "glossary": "Glossary",
  "groups": {
    "dataModel": "Data model",
    "documents": "Documents",
    "reference": "Reference",
    "settings": "Settings and administration",
    "start": "Get started",
    "work": "Working in DMW"
  },
  "guide": "Guide",
  "next": "Next",
  "notFound": {
    "start": "Go to the start of the help.",
    "text": "The link may be out of date.",
    "title": "This help page does not exist"
  },
  "onThisPage": "On this page",
  "open": "Help",
  "pager": "Previous and next page",
  "previous": "Previous",
  "search": {
    "label": "Search the help",
    "none": "Nothing found for “{{query}}”.",
    "placeholder": "Search the help (/)",
    "results": "Results"
  },
  "skipToContent": "Skip to the page",
  "thisPage": "Help on this page",
  "title": "Help",
  "topics": "Topics"
}
